import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';

import FieldSelect from '../common/FieldSelect';
import FieldText from '../common/FieldText';

import TowerAPI from '../../api/TowerAPI';
import PropertyAPI from '../../api/PropertyAPI';
import RoomAPI from '../../api/RoomAPI';
import ApiUiController from '../../controller/ApiUiController';
import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import Display from '../../util/Display';

class TowerRoomUpdate extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.tower_details;
    this.id = parseInt(props.match.params.towerId);
    this.projectId = parseInt(props.location.search.substr(props.location.search.indexOf('=') + 1));
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.base = this.props.match.path
    this.base = this.base.substring(0, this.base.lastIndexOf('/mass'));

    this.state = { inApiCall: true, rooms: [], viewRooms: []};
  }

  UNSAFE_componentWillReceiveProps(props) {
    TowerAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
  }

  componentDidMount() {
    PropertyAPI.getInnerProjectList(this.projectId, this.onPropertyReceived, () => {}); 
  }

  onPropertyReceived = res => {
    const options = res.data.map(property => {
      let label = Display.FieldValue(property, 'property_type', this.models.property.fields);
        label += "-" + property.build_area + "-" + property.price;
      return { label, value: property.id };
    });
    this.models.room.fields.property.options = options;
    TowerAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
  }

  onReceived = res => {
    this.tower = res;
    if(this.HideOthersContact) {
      if(!this.project.responsible_person.includes('~'+this.user.user_id+'~')){ this.HideOtherContactView = true;}
    }

    RoomAPI.getInnerList(Const.Tower, this.id, this.onRoomsReceived, this.props.failure, this.props.logout);
  }

  onRoomsReceived = res => this.setState({ ...this.state, inApiCall: false, 
    rooms: [ ...res.data], viewRooms: [ ...res.data] });

  onSave = () => {
    const rooms = [ ...this.state.rooms ];
    const viewRooms = [ ...this.state.viewRooms ];
    const fields = Object.keys(rooms[0]);
    const updatedRooms = [ ];
    for(let i = 0; i < rooms.length; i++) {
      for(let j = 0; j < fields.length; j++) {
        if(rooms[i][fields[j]] !== viewRooms[i][fields[j]]) {
          updatedRooms.push(viewRooms[i]);
          break;
        }
      }
    }

    if(updatedRooms.length > 0) {
      this.setState({ ...this.state, inApiCall: false });
      RoomAPI.massUpdate(updatedRooms, this.onSaved, this.props.failure, this.props.logout);
    }
  }

  onSaved = () => this.props.navigate(`${this.base}/${this.id}?project=${this.projectId}`);

  onChange = (index, field, value) => {
    const viewRooms = [ ...this.state.viewRooms ];
    const viewRoom = { ...viewRooms[index] };
    viewRoom[field] = value;
    viewRooms[index] = viewRoom;
    this.setState({ ...this.state, viewRooms });
  }

  showList = () => this.state.viewRooms.map((room, i) => (
    <tr key={`room_${i}`}>
      <td>
        <FieldText id="room_name" field={this.models.room.fields.room_name}
          value={room.room_name} onValueChange={(field, value) => this.onChange(i, field, value)} inValid={{}} />
      </td>
      <td>
        <FieldText id="floor_no" field={this.models.room.fields.floor_no}
          value={room.floor_no} onValueChange={(field, value) => this.onChange(i, field, value)} inValid={{}} />
      </td>
      <td>
        <FieldSelect id="property" field={this.models.room.fields.property}
          value={room.property} onValueChange={(field, value) => this.onChange(i, field, value)} inValid={{}} />
        </td>
      <td>
        <FieldSelect id="room_status" field={this.models.room.fields.room_status}
          value={room.room_status} onValueChange={(field, value) => this.onChange(i, field, value)} inValid={{}} />
      </td>
    </tr>
  ));
  
  render() {
    let uiCalls = this.showList();
    if (this.state.rooms.length === 0) {
      uiCalls = <tr><td colSpan="4">No Records Found</td></tr>;
    }
    return (
      <section className="previewpage"> 
        <ApiUiController inApiCall={this.state.inApiCall}>
          <div className="container-fluid">  
            <div className="row lead-mt">
              <div className="col-md-4">
                <div className="title_page">
                  <h2>Project: - {Display.ModelLabelValue("project", this.projectId)}</h2>
                  <h2>Tower - {this.tower ? this.tower.tower_name : ''}</h2>
                </div>
              </div>
              <div className="col-md-4">
                <Button className="buttons btn-success" onClick={this.onSave}>Save</Button>
              </div>
            </div>

            <div className="row tablesrow">
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Room No</th>
                      <th>Floor No</th>
                      <th>Configuration</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>{uiCalls}</tbody>
                </Table>
              </div>
            </div>
          </div>
        </ApiUiController>
      </section>
    );
  }
}
export default withRouter(TowerRoomUpdate);